"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var wagtailConfig_1 = require("../../../config/wagtailConfig");
var MediaBlock_1 = __importDefault(require("../blocks/MediaBlock"));
/**
 * Editor block to preview and edit images.
 */
var ImageBlock = function (props) {
    var blockProps = props.blockProps;
    var entity = blockProps.entity, onEditEntity = blockProps.onEditEntity, onRemoveEntity = blockProps.onRemoveEntity;
    var _a = entity.getData(), src = _a.src, alt = _a.alt;
    var altLabel = wagtailConfig_1.STRINGS.DECORATIVE_IMAGE;
    if (alt) {
        altLabel = wagtailConfig_1.STRINGS.ALT_TEXT + ": \u201C" + alt + "\u201D";
    }
    return (react_1["default"].createElement(MediaBlock_1["default"], __assign({}, props, { src: src, alt: "" }),
        react_1["default"].createElement("p", { className: "ImageBlock__alt" }, altLabel),
        react_1["default"].createElement("button", { className: "button Tooltip__button", type: "button", onClick: onEditEntity }, wagtailConfig_1.STRINGS.EDIT),
        react_1["default"].createElement("button", { className: "button button-secondary no Tooltip__button", onClick: onRemoveEntity }, wagtailConfig_1.STRINGS.DELETE)));
};
ImageBlock.propTypes = {
    block: prop_types_1["default"].object.isRequired,
    blockProps: prop_types_1["default"].shape({
        editorState: prop_types_1["default"].object.isRequired,
        entity: prop_types_1["default"].object,
        onChange: prop_types_1["default"].func.isRequired,
    }).isRequired,
};
exports["default"] = ImageBlock;
